import { cn } from '@/lib/utils'

/**
 * Radiance Dental tooth mark. Inherits color via `currentColor`.
 */
export function BrandMark({ className, size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      aria-hidden="true"
    >
      <path
        d="M16 6c-2.6 0-3.9 1-5.4 1-1.7 0-3 1.5-3 3.4 0 1.7.6 3.2 1.3 5.3.4 1.5.8 2.9 1.1 4.6.3 2.3 1.2 3.6 2.5 3.6 1 0 1.4-.8 1.9-2.5l.6-2.5c.2-.7.6-1.1 1-1.1s.8.4 1 1.1l.6 2.5c.4 1.7.9 2.5 1.9 2.5 1.3 0 2.2-1.3 2.5-3.6.3-1.7.6-3.1 1.1-4.6.7-2 1.3-3.6 1.3-5.3 0-1.9-1.3-3.4-3-3.4-1.5 0-2.8-1-5.4-1Z"
        fill="currentColor"
      />
      <circle cx="22.5" cy="9" r="2" fill="currentColor" opacity="0.45" />
    </svg>
  )
}

export function BrandLockup({ className, compact = false }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-700 text-cream shadow-soft">
        <BrandMark size={22} />
      </div>
      {!compact && (
        <div className="flex flex-col leading-tight">
          {/* <span className="h-display text-[15px] font-bold text-ink-900">
            Radiance
          </span> */}
          <span className="text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-700">
            Dental Clinic
          </span>
        </div>
      )}
    </div>
  )
}
